import {
  InspectionDataOptions,
  InspectionReportParts,
  InspectionTemplateData,
} from '../types/model/common';
import { SectionConfigOnView } from '../types/onView/common';
import { SingleInspectionReportOnView } from '../types/onView/singleInspectionReportOnView';
import { sectionConfigFromOnView } from './reportConfigOnView';

function gatedSectionConfig(
  gate: boolean,
  value: SectionConfigOnView
): ReturnType<typeof sectionConfigFromOnView> {
  return {
    ...sectionConfigFromOnView(value),
    enabled: gate && value.enabled,
  };
}

export function deriveInspectionReportPartsFromForm(
  values: SingleInspectionReportOnView
): InspectionReportParts {
  return {
    inspectionInfo: values.inspectionInfo,
    summary: values.summary,
    checklist: values.checklistSectionEnabled,
    issueRegister: values.issueDataSectionEnabled,
    signatures: values.signatures,
  };
}

export function deriveInspectionTemplateDataFromForm(
  values: SingleInspectionReportOnView
): InspectionTemplateData {
  const template = values.templateSectionEnabled;
  const checklist = values.checklistSectionEnabled;

  return {
    generalStandard: template && values.generalStandard,
    generalStandardAttachments: gatedSectionConfig(
      template,
      values.generalStandardAttachments
    ),
    sectionDescriptions: checklist && values.sectionDescriptions,
    sectionAttachments: gatedSectionConfig(
      checklist,
      values.sectionAttachments
    ),
    controlledElementStandard: checklist && values.controlledElementStandard,
    controlledElementStandardAttachments: gatedSectionConfig(
      checklist,
      values.controlledElementStandardAttachments
    ),
  };
}

export function deriveInspectionDataOptionsFromForm(
  values: SingleInspectionReportOnView
): InspectionDataOptions {
  const checklist = values.checklistSectionEnabled;

  return {
    controlledElementAttachments: gatedSectionConfig(
      checklist,
      values.controlledElementAttachments
    ),
    showNotApplicable: checklist && values.showNotApplicable,
    showUnchecked: checklist && values.showUnchecked,
  };
}

export function deriveLinkToHustroFromForm(
  values: SingleInspectionReportOnView
): boolean {
  return values.issueDataSectionEnabled && values.linkToHustro;
}
